<script setup lang="ts">
import { StarIcon } from "@heroicons/vue/24/solid";
import { useStars } from "../composables/useStars";

const stars = useStars();

interface Props {
  rating: number | null;
  haveAttractions?: boolean;
  light?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  rating: null,
  haveAttractions: false,
  light: false,
});

// getStars acota a un entero 0-5: fuera de rango, `5 - hotelRating` daría un
// Array(negativo/NaN) en el v-for de abajo y reventaría TODA la lista de hoteles.
const hotelRating = stars.getStars(props.rating);
</script>

<template>
  <div class="flex w-fit gap-2 items-center flex-wrap">
    <div
      v-tooltip="
        hotelRating
          ? `Rating ${hotelRating} de 5`
          : 'Sin rating registrado'
      "
      class="flex w-fit"
    >
      <StarIcon
        v-for="star in hotelRating"
        :key="star"
        :class="['star', !haveAttractions && 'w-5 h-5']"
      ></StarIcon>
      <StarIcon
        v-for="number in 5 - hotelRating"
        :key="number"
        :class="[
          'star star--remain',
          !haveAttractions && 'w-5 h-5',
          light && '!text-gray-50',
        ]"
      ></StarIcon>
    </div>

    <figure v-if="hotelRating === 0">
      <p
        :class="[
          'p-1 whitespace-nowrap border-slate-400 border-2 rounded-md text-xs',
          light ? 'text-gray-50' : 'text-gray-700',
        ]"
      >
        Sin rating
      </p>
    </figure>
  </div>
</template>

<style>
.star {
  @apply h-2 w-2 !text-blue-600;
}

.star--remain {
  @apply !text-gray-500;
}

.star--xl {
  @apply !h-2 !w-2;
}
</style>
